import { useLazyCurrentUserQuery } from '@entities/current-user/api/credentials-user-api';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { getCredentials } from '@shared/lib/utils/credentials/credentials';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { useEffect } from 'react';

export const useCurrentUser = () => {
    const user = useCurrentUserSelector();
    const [getUser, getUserResult] = useLazyCurrentUserQuery();
    const userError = getQueryError(getUserResult);

    useEffect(() => {
        const isLoggedIn = getCredentials().accessToken;
        if (!user && isLoggedIn) {
            getUser();
        }
    }, [user]);

    return {
        isLoadingUser: getUserResult.isLoading || getUserResult.isFetching || getUserResult.isUninitialized,
        isInitialized: Boolean(getUserResult.data),
        userError,
    };
};
